var _defs, _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccAtm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ATM",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8377",
    "data-name": "Rectangle 8377",
    width: 28,
    height: 28,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35869",
    "data-name": "Path 35869",
    d: "M2.005,12.653h23.62V2.422H2.005Zm21.41-1.672H3.887V4.1H23.415Z",
    fill: "#b3b5c4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8375",
    "data-name": "Rectangle 8375",
    width: 15.251,
    height: 2.789,
    transform: "translate(6.374 6.144)",
    fill: "#b3b5c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35222",
    "data-name": "Group 35222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35221",
    "data-name": "Group 35221",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35870",
    "data-name": "Path 35870",
    d: "M19.208,7.539H8.515a1.271,1.271,0,0,0-1.3,1.241v15.5a1.271,1.271,0,0,0,1.241,1.3H19.208a1.27,1.27,0,0,0,1.3-1.241V8.841a1.219,1.219,0,0,0-1.133-1.3,1.164,1.164,0,0,0-.167,0M18.558,22.6a.933.933,0,0,1-.93.93h-1.3a.932.932,0,0,1-.929-.93V20.558a.932.932,0,0,1,.929-.93h1.3a.933.933,0,0,1,.93.93Z",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8376",
    "data-name": "Rectangle 8376",
    width: 2.697,
    height: 18.04,
    transform: "translate(10.001 7.539)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccAtm);
export default __webpack_public_path__ + "static/media/mcc_atm.f464300928ad5f54201d4906824f4ffd.svg";
export { ForwardRef as ReactComponent };